import { Stack } from '@mui/material';
import AuthScreenContainer from './AuthScreenContainer';
import { AuthContextProvider } from './Context';
import { authClasses, Content, Root } from './styles';
import AcadlyLogo from '../../icons/AcadlyLogo';
import Typography from '../../components/Typography';
import AttendanceCircularIcon from '../../icons/AttendanceCircularIcon';
import { useTranslation } from 'react-i18next';
import { i18nNS } from '../../i18n';
import PollIcon from '../../icons/PollIcon';

const AuthPageContent = () => {
  const { t } = useTranslation([i18nNS.AUTH, i18nNS.SHARED]);
  return (
    <Root>
      <Content className={authClasses.content}>
        <Stack pt={16} px={8} gap={2}>
          <AcadlyLogo />
          <Typography variant="h4Bold">{t('for_powerpoint', { ns: i18nNS.SHARED })}</Typography>
        </Stack>
        <Stack flex={1} justifyContent="center" px={8} gap={6}>
          <Stack direction="row" gap={3}>
            <PollIcon size={60} />
            <Stack gap={1}>
              <Typography variant="h4Medium">{t('embed_acadly_polls', { ns: i18nNS.AUTH })}</Typography>
              <Typography variant="paragraphMedium">
                {t('display_student_responses_in_the_slide', { ns: i18nNS.AUTH })}
              </Typography>
            </Stack>
          </Stack>
          <Stack direction="row" gap={3}>
            <AttendanceCircularIcon size={60} />
            <Stack gap={1}>
              <Typography variant="h4Medium">{t('take_attendance', { ns: i18nNS.AUTH })}</Typography>
              <Typography variant="paragraphMedium">
                {t('mark_presence_of_hundreds_without_breaking_flow', { ns: i18nNS.AUTH })}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Content>
      <Stack className={authClasses.authScreens}>
        <AuthScreenContainer />
      </Stack>
    </Root>
  );
};

const AuthPage = () => {
  return (
    <AuthContextProvider>
      <AuthPageContent />
    </AuthContextProvider>
  );
};

export default AuthPage;
